import { Avatar, AvatarFallback } from "@shared-kernel/primary/shared/shadcn/ui/avatar";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@shared-kernel/primary/shared/shadcn/ui/tooltip";
import { getInitials } from "@utils/formatting";

interface StackedAvatarItem {
  firstName: string;
  lastName: string;
}

interface Props {
  items: StackedAvatarItem[];
  max?: number;
}

export const StackedAvatars = ({ items, max = 3 }: Props) => {
  if (items.length === 0) return <span className="text-sm text-muted-foreground">-</span>;

  const visible = items.slice(0, max);
  const remaining = items.length - max;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className="flex -space-x-2">
            {visible.map((item, index) => (
              <Avatar key={index} className="size-8 border-2 border-background">
                <AvatarFallback className="bg-purple-100 text-xs font-medium text-purple-700">
                  {getInitials(`${item.firstName} ${item.lastName}`)}
                </AvatarFallback>
              </Avatar>
            ))}
            {remaining > 0 && (
              <Avatar className="size-8 border-2 border-background">
                <AvatarFallback className="bg-muted text-xs font-medium">+{remaining}</AvatarFallback>
              </Avatar>
            )}
          </div>
        </TooltipTrigger>
        <TooltipContent>
          <div className="flex flex-col gap-0.5">
            {items.map((item, index) => (
              <span key={index}>
                {item.firstName} {item.lastName}
              </span>
            ))}
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
